import { useForm, UseFormReturn } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

type UseCreateCustomRoleForm = () => UseFormReturn;

export const useCreateCustomRoleForm: UseCreateCustomRoleForm = () => {
  const schema = yup.object().shape({
    id: yup
      .string()
      .required('Custom role id is required')
      .min(3)
      .max(256),
    name: yup.string().required('Custom role name is required').min(3).max(256),
  });

  return useForm({
    resolver: yupResolver(schema),
    mode: 'onChange',
  });
};
